export const SHELL_I18N_NAMESPACE = 'external_shell';
